<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-12 col-sm-12 mb-3">
        <div class="card p-4">
          <div class="media">
            <div class="avatar-sm mr-3">
              <span
                class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22"
              >
                <i class="bx bxl-codepen bx-xl"></i>
              </span>
            </div>
            <div class="media-body">
              <h5 class="mt-3">GALAXY</h5>
            </div>
          </div>
          <div class="row mt-5 mb-3">
            <div class="col-sm-12">
              <button
                class="btn btn-info rounded mr-1"
                @click="typeSelect('telegram')"
              >
                TELEGRAM
              </button>
              <button class="btn btn-success rounded disabled mr-1">
                WHATSHAPP
              </button>
              <button class="btn btn-primary rounded disabled">SIGNAL</button>
            </div>
          </div>

          <div v-if="loadingsearch" class="row mt-5 mb-5 pb-4 mx-auto">
            <div class="text-center m-5 p-5">
              <b-spinner label="Loading..."></b-spinner>
              <br />
              loading..
            </div>
          </div>

          <div
            v-if="!loadingsearch && !select_telegram"
            class="row mt-5 mb-5 pb-4 mx-auto"
          >
            <div class="text-center m-5 p-5">select data</div>
          </div>

          <div class="row" v-if="!loadingsearch && select_telegram">
            <Telegram :user_type="'superadmin'" />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import GroupService from "@/helpers/group.service.js";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import PreferenceService from "@/helpers/preference.service.js";
import appConfig from "@/app.config";
import Telegram from "./galaxy-telegram.vue";
import moment from "moment";
import Swal from "sweetalert2";

// import i18n from "../i18n";
export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Telegram },
  data() {
    return {
      key_id: this.$route.query.id,
      avatar: process.env.VUE_APP_BASE_API_URL_OSINT + "stream-img/?name=",
      loading: false,
      user: "",
      select_telegram: false,
      loadingleave: false,
      created_at_grouplist: "",
      loadingupdate: false,
      loadingsearch: false,
      listGroup: [],
      totalResult: "",
      SearchResult: [],
      searchKey: "",
      elastic: "",
      search: false,
      error: "",
      tableData: [],
      title: "Galaxy",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Galaxy",
          active: true,
        },
      ],
    };
  },

  methods: {
    typeSelect(data) {
      if (data == "telegram") {
        this.select_telegram = true;
      }
    },
  },

  mounted() {
    if (this.key_id) {
      if (this.key_id != "telegram") {
        this.select_telegram = true;
      }
    }
  },
};
</script>

<style scoped>
.badge {
  border-radius: 2%;
}
.btn {
  border-radius: 7%;
}
</style>
